import './AutenticarLoading.css';

const AutenticarLoading = () => {
  return (
    <div className="parentDisable">
      <div className="overlayBox">
        <div className="sk-chase">
          <div className="sk-chase-dot"></div>
          <div className="sk-chase-dot"></div>
          <div className="sk-chase-dot"></div>
          <div className="sk-chase-dot"></div>
          <div className="sk-chase-dot"></div>
          <div className="sk-chase-dot"></div>
        </div>
      </div>
    </div>
  );
};

export default AutenticarLoading;
